import { Component, Input, OnInit } from '@angular/core'
import {
	organizationFilter,
	organizationsList,
} from '../../models/organizations.model'
import { environment } from 'src/environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { ActivationStatus } from 'src/app/shared/enums/general.enum'
import { Router } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'
import { Subscription } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { OrganizationsService } from '../../services/organizations.service'

@Component({
	selector: 'app-organizations-table',
	templateUrl: './organizations-table.component.html',
	styleUrls: ['./organizations-table.component.scss'],
})
export class OrganizationsTableComponent implements OnInit {
	@Input() organizations: organizationsList[] = []
	@Input() organizationFilter: organizationFilter = {
		paging: { pageNumber: 1, pageSize: 10 },
		SearchText: '',
		status: 1,
		startDate: '',
		endDate: '',
		includeActive: false,
		includeInActive: false,
		countryId: null,
		includeSalon: null,
		includeStore: null,
	}
	@Input() totalCount = 0
	subscription = new Subscription()
	imagePath = environment.attachmentPath
	statusEnum = ActivationStatus
	hoverId!: number | null
	inCompleteDataHover: boolean = false
	constructor(
		public translate: TranslateService,
		private toaster: ToastrService,
		private organizationsService: OrganizationsService,
		private router: Router,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {}

	takeAction(action: string, obj: organizationsList) {
		if (action == 'view') {
			this.organizationFilter.status == 1 || this.organizationFilter.status == 3
				? this.router.navigateByUrl(
						`/layout/service-providers/pending-actions/${obj.id}`
				  )
				: this.router.navigateByUrl(
						`/layout/service-providers/organization-profile/${obj.id}`
				  )
		}
	}
}
